import { useController } from "react-hook-form";

import InlineFormInput from "../../FormGroups/InlineFormInput";

export default function Edit({ command, commandIdx, control, errors }) {
    const waypointYaw = useController({
        name: `commands.${commandIdx}.settings.yaw`,
        control,
        defaultValue: command.settings?.yaw ?? "",
    });

    const waypointUseFlyzoneYaw = useController({
        name: `commands.${commandIdx}.settings.useFlyzoneYaw`,
        control,
        defaultValue:
            command.settings?.useFlyzoneYaw ??
            (command.settings?.yaw === undefined ||
                command.settings?.yaw === ""),
    });

    const yawSelectionOptions = [
        { value: true, label: "Flyzone yaw" },
        { value: false, label: "Custom yaw" },
    ];

    // Custom onChange to handle additional logic
    const handleYawTypeChange = (value) => {
        const isCustom = value === false;
        if (!isCustom) {
            waypointYaw.field.onChange(""); // Ensure yaw is cleared if "Flyzone yaw" is selected
        }
    };

    const takePictureOptions = [
        { value: true, label: "Take picture" },
        { value: false, label: "No picture" },
    ];

    const waypointTakePicture = useController({
        name: `commands.${commandIdx}.settings.take_picture`,
        control,
        defaultValue: command.settings?.take_picture ?? false,
    });

    useController({
        name: `commands.${commandIdx}.settings.take_picture_delay_before`,
        control,
        defaultValue: command.settings?.take_picture_delay_before ?? 2,
    });

    useController({
        name: `commands.${commandIdx}.settings.take_picture_delay_after`,
        control,
        defaultValue: command.settings?.take_picture_delay_after ?? 0.5,
    });

    return (
        <>
            <span className="my-2 mx-1">xyz</span>
            <InlineFormInput
                name={`commands.${commandIdx}.settings.x`}
                control={control}
                defaultValue={command.settings?.x || ""}
                errors={errors?.commands?.[commandIdx]?.settings?.x}
                placeholder="x"
                inputType="text"
                unit="m"
            />

            <InlineFormInput
                name={`commands.${commandIdx}.settings.y`}
                control={control}
                defaultValue={command.settings?.y || ""}
                errors={errors?.commands?.[commandIdx]?.settings?.y}
                placeholder="y"
                inputType="text"
                unit="m"
            />

            <InlineFormInput
                name={`commands.${commandIdx}.settings.z`}
                control={control}
                defaultValue={command.settings?.z || ""}
                errors={errors?.commands?.[commandIdx]?.settings?.z}
                placeholder="z"
                inputType="text"
                unit="m"
            />

            <InlineFormInput
                name={`commands.${commandIdx}.settings.useFlyzoneYaw`}
                control={control}
                defaultValue={command.settings?.useFlyzoneYaw ?? true}
                errors={errors?.commands?.[commandIdx]?.settings?.useFlyzoneYaw}
                placeholder="Yaw Selection"
                inputType="select"
                options={yawSelectionOptions}
                onChange={handleYawTypeChange}
                field={waypointUseFlyzoneYaw.field}
            />

            {!waypointUseFlyzoneYaw.field.value && (
                <InlineFormInput
                    name={`commands.${commandIdx}.settings.yaw`}
                    control={control}
                    defaultValue={command.settings?.yaw ?? ""}
                    errors={errors?.commands?.[commandIdx]?.settings?.yaw}
                    placeholder="yaw"
                    inputType="text"
                    unit="°"
                    field={waypointYaw.field}
                />
            )}

            {waypointTakePicture.field.value && (
                <>
                    <span className="my-2 mx-2">Wait before picture:</span>
                    <InlineFormInput
                        name={`commands.${commandIdx}.settings.take_picture_delay_before`}
                        control={control}
                        defaultValue={
                            command.settings?.take_picture_delay_before ?? 2
                        }
                        errors={
                            errors?.commands?.[commandIdx]?.settings
                                ?.take_picture_delay_before
                        }
                        placeholder="time"
                        inputType="text"
                        unit="s"
                    />
                </>
            )}

            <InlineFormInput
                name={`commands.${commandIdx}.settings.take_picture`}
                control={control}
                defaultValue={command.settings?.take_picture ?? false}
                errors={errors?.commands?.[commandIdx]?.settings?.take_picture}
                placeholder="Take picture?"
                inputType="select"
                options={takePictureOptions}
                field={waypointTakePicture.field}
            />

            {waypointTakePicture.field.value && (
                <>
                    <span className="my-2 mx-2">Wait after picture:</span>
                    <InlineFormInput
                        name={`commands.${commandIdx}.settings.take_picture_delay_after`}
                        control={control}
                        defaultValue={
                            command.settings?.take_picture_delay_after ?? 0.5
                        }
                        errors={
                            errors?.commands?.[commandIdx]?.settings
                                ?.take_picture_delay_after
                        }
                        placeholder="time"
                        inputType="text"
                        unit="s"
                    />
                </>
            )}
        </>
    );
}
